import {
  Text,
  Avatar,
  Tag,
  HStack,
  VStack,
  WrapItem,
  Divider,
  Flex,
  GridProps,
} from '@chakra-ui/react';
import { format } from 'date-fns';
import { useTranslation } from 'next-i18next';
import { ListingProps } from '@/types/listing';
import ContentSection, {
  SectionHeading,
} from '@/components/frontend/ContentSection';
import UserAvatar from '../../common/UserAvatar';

const QuestionSection = ({
  listing,
  ...gridStyles
}: Pick<ListingProps, 'listing'> & GridProps) => {
  const { t } = useTranslation(['backoffice', 'frontoffice']);

  return (
    <ContentSection {...gridStyles}>
      <SectionHeading>
        {t('frontoffice:questions', 'Kysymykset')}
        <Tag colorScheme="primary" borderRadius="full" ml={2} fontSize="sm">
          {listing?.listing_questions_and_answers?.length || 0}
        </Tag>
      </SectionHeading>
      {!listing?.listing_questions_and_answers.length ? (
        <Text>
          {t(
            'frontoffice:no_questions',
            'Kohteesta ei ole esitetty vielä kysymyksiä, kysymyksiä voi esittää yhteydenottolomakkeen kautta.',
          )}
        </Text>
      ) : (
        <VStack
          spacing={5}
          align="flex-start"
          divider={<Divider borderColor="gray.400" />}
        >
          {listing?.listing_questions_and_answers?.map((x) => (
            <VStack align="flex-start" spacing={5} key={x.id} py={3}>
              <HStack spacing={5} align="flex-start">
                <WrapItem>
                  <Avatar size="md" />
                </WrapItem>
                <VStack align="flex-start" spacing={1}>
                  <Text fontWeight="bold" fontSize="sm" justifyContent="center">
                    {t('customer', 'Asiakas')}
                  </Text>
                  <Text whiteSpace="pre-line">{x.question}</Text>
                  <Text fontSize="xs" color="gray.500">
                    {format(
                      new Date(x.created_at as string),
                      'dd.MM.yyyy, HH:mm',
                    )}
                  </Text>
                </VStack>
              </HStack>
              <HStack spacing={5} align="flex-start">
                <WrapItem>
                  <UserAvatar size="md" user={x.user} />
                </WrapItem>
                <VStack align="flex-start" spacing={1}>
                  <Flex>
                    <Text
                      fontWeight="bold"
                      fontSize="sm"
                      justifyContent="center"
                      mr={2}
                    >
                      {x.user?.name}
                    </Text>
                    <Tag size="sm" colorScheme="primary">
                      {t('realtor', 'Välittäjä')}
                    </Tag>
                  </Flex>
                  <Text whiteSpace="pre-line">{x.answer}</Text>
                  <Text fontSize="xs" color="gray.500">
                    {format(
                      new Date(x.updated_at as string),
                      'dd.MM.yyyy, HH:mm',
                    )}
                  </Text>
                </VStack>
              </HStack>
            </VStack>
          ))}
        </VStack>
      )}
    </ContentSection>
  );
};

export default QuestionSection;
